import Vue from "vue";
import Router from "vue-router";
import AllFrontend from "@/components/frontend/components";
import AllBackend from "@/components/backend/components";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: AllBackend.Login
    },
    {
      path: "/registration",
      name: "Registration",
      component: AllFrontend.Register
    },
    {
      path: "/roadmap",
      name: "TimeLine",
      component: AllFrontend.TimeLine
    },
    {
      path: "/legal",
      name: "LegalTec",
      component: AllFrontend.LegalTec,
      alias: "/legal/tec"
    },
    {
      path: "/legal/tecb",
      name: "LegalTecB",
      component: AllFrontend.LegalTecB
    },
    {
      path: "/legal/affil",
      name: "LegalEULACoupon",
      component: AllFrontend.LegalEULACoupon
    },
    {
      path: "/affil",
      name: "RegisterFidel",
      component: AllFrontend.RegisterFidel
    },
    {
      path: "/legal/cookie",
      name: "CookieP",
      component: AllFrontend.CookieP
    },
    {
      path: "/legal/eula",
      name: "LegalEULA",
      component: AllFrontend.LegalEULA
    },
    // backend stuff
    {
      path: "/admin/login",
      name: "Login",
      component: AllBackend.Login
    },
    {
      path: "/admin",
      component: AllBackend.Shell,
      meta: {
        requiresAuth: true
      },
      /* redirect: to => {
        if (to.name != 'Home')
          return to.path;
      }, */
      children: [
        {
          path: "",
          name: "HomeBackEnd",
          alias: ["/admin/dash", "/admin/elcarro"],
          component: AllBackend.Dashboard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "dashboard",
          name: "Dashboard",
          alias: ["/admin/dash", "/admin/elcarro"],
          component: AllBackend.Dashboard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "calendar/:id",
          name: "Calendar",
          component: AllBackend.Calendar,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "calendar",
          name: "CalendarSimple",
          component: AllBackend.Calendar,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "shops/details",
          name: "ShopsSimple",
          component: AllBackend.Shops,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "shops/:id", 
          name: "Shops",
          component: AllBackend.Shops,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "me",
          name: "Profile",
          alias: "/admin/profile",
          component: AllBackend.Profile,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "payments",
          name: "Pay",
          component: AllBackend.Payments,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "manager",
          name: "Manager",
          component: AllBackend.Manager,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "info",
          name: "Info",
          alias: "/admin/about",
          component: AllBackend.About,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "fid",
          name: "Fidelity",
          alias: "/admin/fidelity",
          component: AllBackend.Fidelity,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "qcal",
          name: "QuickCal",
          alias: "/admin/quickcal",
          component: AllBackend.QCal,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "tutorial",
          name: "VideoTutorial",
          alias: "/admin/about",
          component: AllBackend.VideoTutorial,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "marketing",
          name: "Marketing",
          alias: "/admin/mark",
          component: AllBackend.Marketing,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "com",
          name: "Communication",
          alias: "/admin/communication",
          component: AllBackend.Communication,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "autonotif",
          name: "AutoNotifications",
          alias: "/admin/autonotifications",
          component: AllBackend.AutoNotifications,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "comm",
          name: "CommunicationAdmin",
          alias: "/admin/communicationAdmin",
          component: AllBackend.CommunicationAdmin,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "ecom",
          name: "ECommerce",
          alias: "/admin/ecommerce",
          component: AllBackend.Ecommerce,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "diag",
          name: "Diagnostics",
          alias: "/admin/diagnostics",
          component: AllBackend.Diagnostics,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "server",
          name: "Server",
          component: AllBackend.Server,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js